import React from "react";
import { Box, CircularProgress } from "@mui/joy";
import { useCustomer } from "../../../contexts/api";
import type { ZekayCustomer } from "../../../api/customers/Customer.typed";
import TrainingList from "./TrainingList";
import DarkTypography from "../../common/DarkTypography";
import { textTokens } from "../../../styles/globalStyles";

type Props = {
  customerId: number;
};

export default function CustomerTrainingsTab({ customerId }: Props) {
  const { getCustomer } = useCustomer();
  const [customer, setCustomer] = React.useState<ZekayCustomer | undefined>();
  const [loading, setLoading] = React.useState(true);

  const refreshCustomer = React.useCallback(async () => {
    const fresh = await getCustomer(String(customerId));
    setCustomer(fresh);

    return fresh;
  }, [customerId, getCustomer]);

  React.useEffect(() => {
    setLoading(true);
    getCustomer(String(customerId))
      .then((c) => setCustomer(c))
      .finally(() => setLoading(false));
  }, [customerId, getCustomer]);

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", py: 3 }}>
        <CircularProgress size="sm" />
      </Box>
    );
  }

  const trainings = customer?.Trainings;
  if (!trainings || trainings.length === 0) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", py: 3 }}>
        <DarkTypography level="body-sm" sx={{ color: textTokens.color.dimmed }}>
          Aucune formation en cours
        </DarkTypography>
      </Box>
    );
  }

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1, p: 1 }}>
      <TrainingList
        customer={customer}
        setCustomerUpdated={setCustomer}
        setTrainingsOpen={() => {}}
        refreshCustomer={refreshCustomer}
      />
    </Box>
  );
}
